import { useDialog } from "@/client/stores/dialog";
import { ManualCreateUserDto } from "@reactive-resume/dto";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ScrollArea,
  Form,
  FormField,
  FormLabel,
  Input,
  FormItem,
  FormControl,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  Select,
  Label,
  SelectGroup,
  SelectLabel,
} from "@reactive-resume/ui";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { generatePasswordWithOptions } from "password-generator";
import { TypeCoupon } from "@reactive-resume/utils";
import { useRegisterByAdmin } from "@/client/services/user/create-user";
import { CreateCouponDto, UpdateCouponDto } from "libs/dto/src/coupon";
import { useCreateCoupon } from "@/client/services/coupon/create-coupons";
import { useCoupon } from "@/client/services/coupon/coupon";
import { usefilterUser } from "@/client/services/user/filter-user";
import { useRates } from "@/client/services/rate/rates";
import { useUpdateCoupon } from "@/client/services/coupon/update-coupon";
import { useUser } from "@/client/services/user";

export const CreateCouponDialog = () => {
  type FormValue = {
    reduction: number;
    type: string;
    userId?: string;
    rateId?: string;
    startDate: string;
  };
  const formRef = useRef<HTMLFormElement>(null);
  const { user } = useUser();
  const { create } = useCreateCoupon();
  const { update } = useUpdateCoupon();
  const { isOpen, mode, close, payload } = useDialog<{ id: string }>("create-coupon");
  const { coupon } = useCoupon(payload?.item?.id ?? "");
  const { filterUsers } = usefilterUser(false);
  const { rates } = useRates();
  const form = useForm<FormValue>({
    defaultValues: {
      reduction: 0,
      userId: "",
      rateId: "",
      type: "",
      startDate: new Date(Date.now()).toISOString().split("T")[0],
    },
  });

  const isEdit = !!payload?.item?.id;
  const couponId = payload?.item?.id;
  let [isPromo, setIsPromo] = useState(true);

  useEffect(() => {
    if (isEdit && coupon) {
      if (coupon.type == Number("0")) setIsPromo(true);
      if (coupon.type == Number("1")) setIsPromo(false);
      console.log(coupon);
      form.reset({
        reduction: coupon.reduction,
        type: coupon.type.toString(),
        userId: coupon.userId ?? undefined,
        rateId: coupon.rateId ?? undefined,
        startDate: new Date(coupon.startDate).toISOString().split("T")[0],
      });
    }
    if (!isEdit) {
      form.reset({
        reduction: 0,
        userId: user?.role == 2 ? user.id : "",
        rateId: "",
        type: "",
        startDate: new Date(Date.now()).toISOString().split("T")[0],
      });
    }
  }, [coupon, isEdit, form]);

  const OnSubmit = async (data: any) => {
    try {
      if (isEdit) {
        const payload: UpdateCouponDto = {
          reduction: Number(data.reduction),
          type: Number(data.type),
          userId: data.userId ? data.userId : null,
          rateId: data.rateId ? data.rateId : null,
          startDate: new Date(data.startDate),
        };
        update({ id: couponId!, data: payload });
      } else {
        const payload: CreateCouponDto = {
          reduction: Number(data.reduction),
          type: Number(data.type),
          userId: data.userId ? data.userId : null,
          rateId: data.rateId ? data.rateId : null,
          startDate: new Date(data.startDate),
          status: 0,
        };
        create(payload);
      }
      form.reset();
      close();
    } catch {
      form.reset({
        ...data,
      });
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          {isEdit ? (
            <DialogTitle>Modifier le coupon</DialogTitle>
          ) : (
            <DialogTitle>Nouveau coupon</DialogTitle>
          )}
        </DialogHeader>

        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <FormField
              name="reduction"
              control={form.control}
              render={({ field }) => (
                <FormItem>
                  <FormLabel>{`Réduction`}</FormLabel>
                  <FormControl>
                    <Input {...field} />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              name="type"
              control={form.control}
              render={({ field }) => (
                <FormItem className="w-full">
                  <FormLabel>{`Type`}</FormLabel>
                  <Select
                    value={field.value}
                    defaultValue={user?.role == 2 ? "0" : ""}
                    onValueChange={(value) => {
                      field.onChange(value);
                      if (value === "0") setIsPromo(true);
                      if (value === "1") setIsPromo(false);
                    }}
                  >
                    <FormControl>
                      <SelectTrigger className="w-full">
                        <SelectValue placeholder=" Type de coupon" />
                      </SelectTrigger>
                    </FormControl>
                    <SelectContent>
                      <SelectGroup>
                        <SelectLabel>Selectionner un type</SelectLabel>
                        {user?.role != 2 ? (
                          <SelectItem value={TypeCoupon.Reduction.toString()}>
                            {" "}
                            Reduction
                          </SelectItem>
                        ) : null}
                        <SelectItem value={TypeCoupon.Promo.toString()}> Promo</SelectItem>
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </FormItem>
              )}
            />

            {isPromo ? (
              <>
                <FormField
                  name="userId"
                  control={form.control}
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <FormLabel>{`Ambassadeur`}</FormLabel>
                      <Select
                        value={field.value}
                        disabled={user?.role == 2}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Sélectionner un ambassadeur" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <ScrollArea orientation="vertical" className="h-[300px]">
                            {/* <SelectGroup> */}
                            {/* <SelectLabel>Selectionner un client</SelectLabel> */}
                            {filterUsers?.data
                              .slice()
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((item) => {
                                return (
                                  <>
                                    <SelectItem value={item.id}>
                                      {" "}
                                      <span className="font-bold">{item.name}</span> ||{" "}
                                      <span className="text-moncvpro-secondary text-lg font-bold">
                                        {" "}
                                        {item.email}
                                      </span>
                                    </SelectItem>
                                  </>
                                );
                              })}
                            {/* </SelectGroup> */}
                          </ScrollArea>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </>
            ) : (
              <>
                <FormField
                  name="rateId"
                  control={form.control}
                  render={({ field }) => (
                    <FormItem className="w-full">
                      <FormLabel>{`Tarif`}</FormLabel>
                      <Select
                        value={field.value}
                        onValueChange={(value) => {
                          field.onChange(value);
                        }}
                      >
                        <FormControl>
                          <SelectTrigger className="w-full">
                            <SelectValue placeholder="Sélectionner un tarif" />
                          </SelectTrigger>
                        </FormControl>
                        <SelectContent>
                          <ScrollArea orientation="vertical" className="h-[300px]">
                            {/* <SelectGroup> */}
                            {/* <SelectLabel>Selectionner un client</SelectLabel> */}
                            {rates?.data
                              .slice()
                              .sort((a, b) => a.name.localeCompare(b.name))
                              .map((item) => {
                                return (
                                  <>
                                    <SelectItem value={item.id}>
                                      {" "}
                                      <span className="font-bold">{item.name}</span> ||{" "}
                                      <span className="text-moncvpro-secondary text-lg font-bold">
                                        {" "}
                                        {item.price}
                                      </span>
                                    </SelectItem>
                                  </>
                                );
                              })}
                            {/* </SelectGroup> */}
                          </ScrollArea>
                        </SelectContent>
                      </Select>
                    </FormItem>
                  )}
                />
              </>
            )}

            <Label>Date de debut</Label>
            <Input {...form.register("startDate")} type="date" />

            <div className="flex-rows flex justify-center gap-x-2">
              <Button type="submit" className="flex-1">
                {"Valider"}
              </Button>

              <Button className="flex-1" onClick={close}>
                {"Fermer"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
